import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import { fromJS } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import moment from 'moment';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectTripInterruptionStep, makeSelectTripInterruptionStepErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  ValidateGroup,
  Validate,
  ErrorMessage,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormData,
  resetFormTravelInterruption,
  resetFormTravelDelay,
} from './actions';
import {
  emailMedicalTravelDocument,
} from '../../FastCover/actions';
import DatePicker from '../components/DatePicker/index';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import { AdditionalList } from './components/Additional';
import { InsuredList } from './components/AddInsured';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import AsyncButtonSendMail from '../../../components/AsyncButtonSendMail/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import HelpText from '../../../components/HelpText';
import TimePickerInput from '../../../components/TimePickerInput';
import { stepTripInterruptionLookup } from '../../FastCover/dataMapper/claimCodeMapper';
import { required, checkDateOnly } from '../../../utils/validation/validator';

export class TripInterruptionStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
      physicianEmail: false,
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.emailMeDocumentButton = _.uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(6);
  };

  onLossInformationItemsChange = (data) => {
    this.props.onFormDataChange('form.lossInformationItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  // onDelayInformationItemsChange = (data) => {
  //   this.props.onFormDataChange('form.delayInformationItems', fromJS(data));
  //   const { adjust } = this.props;
  //   if (adjust) adjust();
  // };

  onInsuredChange = (data) => {
    this.props.onFormDataChange('form.insureds', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    // this.props.makeDirty(6);
  };

  handleReasonsForTripInterruption = (propertyName) => (event) => {
    const { reasonsForTripInterruption } = this.props.form;
    const reasons = !!reasonsForTripInterruption && typeof reasonsForTripInterruption.toJS === 'function'
      ? reasonsForTripInterruption.toJS()
      : reasonsForTripInterruption || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleReasonsForTripCancellation = (propertyName) => (event) => {
    const { reasonsForTripCancellation } = this.props.form;
    const reasons = !!reasonsForTripCancellation && typeof reasonsForTripCancellation.toJS === 'function'
      ? reasonsForTripCancellation.toJS()
      : reasonsForTripCancellation || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleReasonsForDelay = (propertyName) => (event) => {
    const { reasonsForDelay } = this.props.form;
    const reasons = !!reasonsForDelay && typeof reasonsForDelay.toJS === 'function'
      ? reasonsForDelay.toJS()
      : reasonsForDelay || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleEmailMeButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.sendPhysicianEmail();
  };

  renderAdditionalItems() {
    const { lossInformationItems } = this.props.form;
    const newLossInformationItems = this.appendIds(lossInformationItems);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newLossInformationItems}
          onChange={this.onLossInformationItemsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderInsuredList() {
    const { insureds } = this.props.form;
    const newInsureds = this.appendIds(insureds);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <InsuredList
          data={newInsureds}
          onChange={this.onInsuredChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderTravelInterruption() {
    const {
      travelInterruption,
      areYouInterruptingTheTripDueToMedicalReasons,
      schoolNameForInterruption,
      reasonsForTripInterruption,
      companyNameTravelInterruption,
      addressTravelInterruption,
      cityTravelInterruption,
      stateTravelInterruption,
      zipCodeTravelInterruption,
      contactTravelInterruption,
      phoneNumberTravelInterruption,
      includedInPackage,
      dateTripInterrupted,
      reasonForInterruption,
      nameOfPersonHavingSickness,
      dateOfBirth,
      relationshipToClaimant,
      dateSicknessOrInjuryBegan,
      dateEnded,
      natureOfSicknessOrInjury,
      fromDate,
      toDate,
      dateOfInitialPaymentDeposit,
      enableTime,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const reasonsForTripInterruptions = !!reasonsForTripInterruption && typeof reasonsForTripInterruption.toJS === 'function'
      ? reasonsForTripInterruption.toJS()
      : reasonsForTripInterruption || [];
    const { isSummary, submitted } = this.props;
    const buttonEmailMeDisable = !!enableTime && new Date().getTime() < enableTime;
    const isReadOnly = submitted || isSummary;
    return (
      travelInterruption === 'true' && (
        <div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.insureds} />
            </PageSectionHeader>
            {this.renderInsuredList()}
          </div>
          <div className={'ml-5'}>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.areYouInterruptingTheTripDueToMedicalReasons} />
                </PageSectionHeader>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      checked={areYouInterruptingTheTripDueToMedicalReasons === 'true'}
                      onChange={this.handleChange('form.areYouInterruptingTheTripDueToMedicalReasons')}
                    />
                    <FormattedMessage {...messages.yes} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      checked={areYouInterruptingTheTripDueToMedicalReasons === 'false'}
                      onChange={this.handleChange('form.areYouInterruptingTheTripDueToMedicalReasons')}
                    />
                    <FormattedMessage {...messages.no} />
                  </OptionsContainer>
                </FlexBox>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.schoolName} />
                </PageSectionHeader>
                    <Textbox
                      name="schoolNameForInterruption"
                      type="text"
                      onChange={this.handleChange('form.schoolNameForInterruption')}
                      value={schoolNameForInterruption}
                      disabled={isReadOnly}
                    />
              </div>
            </div>       
            <div className={'row'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelSupplier} />
              </PageSectionHeader>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="companyNameTravelInterruption"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={companyNameTravelInterruption}
                  fieldName={messages.companyNameTravelInterruption}                  
                  >
                    <Textbox
                      name="companyNameTravelInterruption"
                      type="text"
                      onChange={this.handleChange('form.companyNameTravelInterruption')}
                      value={companyNameTravelInterruption}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.companyNameTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="addressTravelInterruption"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={addressTravelInterruption}
                  fieldName={messages.addressTravelInterruption}                  
                  >
                    <Textbox
                      name="addressTravelInterruption"
                      type="text"
                      onChange={this.handleChange('form.addressTravelInterruption')}
                      value={addressTravelInterruption}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.addressTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="cityTravelInterruption"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={cityTravelInterruption}
                  fieldName={messages.cityTravelInterruption}                  
                  >
                    <Textbox
                      name="cityTravelInterruption"
                      type="text"
                      onChange={this.handleChange('form.cityTravelInterruption')}
                      value={cityTravelInterruption}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.cityTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="stateTravelInterruption"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={stateTravelInterruption}
                  fieldName={messages.stateTravelInterruption}                  
                  >
                    <Textbox
                      name="cityTravelInterruption"
                      type="text"
                      onChange={this.handleChange('form.stateTravelInterruption')}
                      value={stateTravelInterruption}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.stateTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="zipCodeTravelInterruption"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={zipCodeTravelInterruption}
                  fieldName={messages.zipCodeTravelInterruption}                  
                  >
                    <Textbox
                      name="cityTravelInterruption"
                      type="text"
                      onChange={this.handleChange('form.zipCodeTravelInterruption')}
                      value={zipCodeTravelInterruption}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.zipCodeTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="contactTravelInterruption"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={contactTravelInterruption}
                  fieldName={messages.contactTravelInterruption}                  
                  >
                    <Textbox
                      name="cityTravelInterruption"
                      type="text"
                      onChange={this.handleChange('form.contactTravelInterruption')}
                      value={contactTravelInterruption}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.contactTravelInterruption}
                      />
                    </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="phoneNumber"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={phoneNumberTravelInterruption}
                  fieldName={messages.phoneNumber}                  
                  >
                    <Textbox
                      name="phoneNumber"
                      type="text"
                      onChange={this.handleChangePhoneNumber('form.phoneNumberTravelInterruption')}
                      value={phoneNumberTravelInterruption}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.phoneNumber}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateOfInitialPaymentDeposit"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateOfInitialPaymentDeposit}
                  fieldName={messages.dateOfInitialPaymentDeposit}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTravelCancellation"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateOfInitialPaymentDeposit')}
                    value={dateOfInitialPaymentDeposit}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateOfInitialPaymentDeposit}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateOfInitialPaymentDeposit}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.includedInPackage} />
                </PageSectionHeader>
                <TextArea
                  disabled={isReadOnly}
                  name="includedInPackage"
                  type="text"
                  onChange={this.handleChange('form.includedInPackage')}
                  value={includedInPackage}
                  isSummary={isSummary}
                />
              </div>
            </div>
          </div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.lossInformation} />
            </PageSectionHeader>
            {this.renderAdditionalItems()}
            <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateTripInterrupted"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateTripInterrupted}
                  fieldName={messages.dateTripInterrupted}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTripInterrupted"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateTripInterrupted')}
                    value={dateTripInterrupted}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripInterrupted}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateTripInterrupted}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-8 form-group'}>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="includedInPackage"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={reasonForInterruption}
                  fieldName={messages.reasonForInterruption}                  
                  >
                      <TextArea
                        disabled={isReadOnly}
                        name="reasonForInterruption"
                        type="text"
                        onChange={this.handleChange('form.reasonForInterruption')}
                        value={reasonForInterruption}
                        isSummary={isSummary}
                      />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.reasonForInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-5 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.nameOfPersonHavingSickness} />
                </PageSectionHeader>
                <Textbox
                      name="nameOfPersonHavingSickness"
                      type="text"
                      onChange={this.handleChange('form.nameOfPersonHavingSickness')}
                      value={nameOfPersonHavingSickness}
                      disabled={isReadOnly}
                    />
              </div>
              <div className={'col-sm-3 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.dateOfBirth} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateOfBirth"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateOfBirth')}
                  value={dateOfBirth}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.relationshipToClaimant} />
                </PageSectionHeader>
                <Textbox
                  name="relationshipToClaimant"
                  type="text"
                  onChange={this.handleChange('form.relationshipToClaimant')}
                  value={relationshipToClaimant}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.dateSicknessOrInjuryBegan} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateSicknessOrInjuryBegan"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateSicknessOrInjuryBegan')}
                  value={dateSicknessOrInjuryBegan}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.dateEnded} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateEnded"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateEnded')}
                  value={dateEnded}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.natureOfSicknessOrInjury} />
                </PageSectionHeader>
                <TextArea
                  disabled={isReadOnly}
                  name="natureOfSicknessOrInjury"
                  type="text"
                  onChange={this.handleChange('form.natureOfSicknessOrInjury')}
                  value={natureOfSicknessOrInjury}
                  isSummary={isSummary}
                />
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.periodOfHospitalization} />
                </PageSectionHeader>
              </div>
              <div className={'form-group col-sm-3'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.fromDate} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="fromDate"
                  type="text"
                  onDayChange={this.handleDayChange('form.fromDate')}
                  value={fromDate}
                />
              </div>
              <div className={'form-group col-sm-3'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.toDate} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="toDate"
                  type="text"
                  onDayChange={this.handleDayChange('form.toDate')}
                  value={toDate}
                />
              </div>
              <div className={'form-group col-sm-6'}>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'form-group col-sm-7'}>
                <HelpText>
                On clicking the button an email with the Statement of Attending Physician will be sent to you. Once sent please check your email.
                </HelpText>
              </div>
              <div className={'form-group col-sm-5'}>
                <AsyncButtonSendMail
                  id={this.emailMeDocumentButton}
                  className={buttonEmailMeDisable ? 'btn-action-success' : 'btn-authentication'}
                  disabled={buttonEmailMeDisable || isReadOnly}
                  loading={this.props.loading}
                  spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                  onClick={this.handleEmailMeButtonClick}
                >
                  Statement of Attending Physician
                </AsyncButtonSendMail>
              </div>
            </div>
          </div>
        </div>
      )
    );
  }

  render() {
    const {
      travelInterruption,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, loading } = this.props;
    const isRenderTravelInterruption = !!stepTripInterruptionLookup.tripInterruption.claimCode;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="app-content">
        {isRenderTravelInterruption &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelInterruption} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={travelInterruption === 'true'}
                    onChange={this.handleChange('form.travelInterruption')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={travelInterruption === 'false'}
                    onChange={this.handleChange('form.travelInterruption')}
                    onClick={this.props.onResetFormTravelInterruption}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>}
        {isRenderTravelInterruption && this.renderTravelInterruption()}
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

TripInterruptionStep.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetFormTravelInterruption: PropTypes.func,
  onResetFormTravelDelay: PropTypes.func,
  sendPhysicianEmail: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectTripInterruptionStep(),
  errors: makeSelectTripInterruptionStepErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormTravelInterruption: () => dispatch(resetFormTravelInterruption()),
  onResetFormTravelDelay: () => dispatch(resetFormTravelDelay()),
  onResetFormData: () => dispatch(resetFormData()),
  sendPhysicianEmail: () => dispatch(emailMedicalTravelDocument()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'tripInterruptionStep', reducer });

export default compose(
  withReducer,
  withConnect
)(TripInterruptionStep);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.TripInterruptionStep/index.js